import React from "react";

import Icon from "@cayuse/shared-react.components.icon";
import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import { FORM_STATUSES } from "globals/constants/form";
import useDictionary from "hooks/useDictionary";

import styles from "./styles.css";

const StatusIcon = ({tabId, status, label}) => {

    const dictionary = useDictionary("common.formResponse");

	const className = `${styles.formStatus} ${status in styles ? styles[status] : ""}`;
	const key = `${tabId}:${status}`;

	const tipHash = {
		complete: dictionary.sectionComplete || "Required questions are complete <br> and section has been viewed",
		unseen: dictionary.sectionUnseen || "Section must be viewed",
		invalid: dictionary.invalidInput || "This section has an invalid input, please review all values within it", /* todo: confirm copy & dictionary */
		missingFields: dictionary.sectionIncomplete || "Section has required questions"
	};

	const icon = status in FORM_STATUSES
		? FORM_STATUSES[status]
		: false;

	const isMissingFields = status === "missingFields";

	return (
		<div key={key} className={className} tabIndex={"-1"}>
			{icon && 
				<Icon className={`${styles.icon} ${status in styles ? styles[status] : ""}`}
					data-for="react-tooltip"
					data-tip={tipHash[status]}
					name={FORM_STATUSES[status]}
					tabIndex={"-1"}
				/>
			}

			{isMissingFields && isNonEmptyString(label) &&
				<div className={`${styles.icon} ${styles.missingFields}`} data-tip={tipHash.missingFields}>{label}</div>
			}
		</div>
	);
};

export default React.memo(StatusIcon);